import { useCameraViewContext } from '../../context';

const underHoodItems = [
  'Main under Hood',
  'Oil Dipstick & Cap',
  'Coolant & Cap',
  'Transmission Dip Stick',
  'Emissions Control Sticker',
  'Exhaust deep both sides (Cat)',
  'Fit & Finish, Body Lines Paint match',
  'Oil or Coolant Leaks',
  'Aftermarket Equipment'
];

const dashItems = ['Dash'];

const interiorItems = ['Driver Seat', 'Passenger Seat', 'Rear Seat', '3RD Seat', 'Headliner', 'Center Stack', 'Dash'];

const tireItems = [
  'Driver Front Tire',
  'Driver Front Wheel',
  'Vin Plate',
  'Driver Rear Tire',
  'Driver Rear Wheel',
  'License Plate/Registration',
  'Passenger Rear Tire',
  'Passenger Rear Wheel',
  'Passenger Front Tire',
  'Passenger Front Wheel'
];

const exteriorParts = ['Offset Front', 'Front', 'Driver Side', 'Rear', 'Rear Plate', 'Passenger Side', 'Roof'];

const fffParts = [
  'Body lines',
  'Paint condition and matching',
  'Doors Hinges & Latches',
  'Anybody work done',
  'Any panel replacement',
  'Check Rear Quarters for weld replacement',
  'Check the Rear wheel tub',
  'Rear bumper and rear of vehicle',
  'Rust',
  'Anything noted under vehicle'
];

const sectionIdToItems = {
  under_hood: underHoodItems,
  interior_questions: interiorItems,
  drive_cycles: dashItems,
  'exterior.subsections.tires': tireItems,
  'exterior.subsections.fit_finish_frame': fffParts,
  'exterior.subsections.exterior': exteriorParts
};

const formatHelperText = (arr: string[]) => {
  return arr.map((v, i) => `${i + 1}.${v}`).join(' ');
};

export const useTipsText = () => {
  const { level1SectionId } = useCameraViewContext();
  console.log(level1SectionId, 'level1SectionId123');

  const items = sectionIdToItems[level1SectionId as keyof typeof sectionIdToItems] || [];
  return formatHelperText(items);
};
